import 'jquery-validation';

export const FormController = () => {
  $('.subscribe-form').each((i, el) => {
    $(el).validate();
  })
}



// WEBPACK FOOTER //
// ./src/js/controllers/FormController.js